<template>
    <a v-if="isExternalLink(to)" :href="to" rel="noopener noreferrer">
        <slot />
    </a>

    <nuxt-link v-else :to="localePath(to)">
        <slot />
    </nuxt-link>
</template>

<script>
import isExternalLink from '@/helpers/isExternalLink';

export default {
    props: {
        to: {
            type: String,
            required: true
        }
    },

    methods: {
        isExternalLink(link) {
            return isExternalLink(link);
        }
    }
};
</script>
